import {Button} from 'antd';
import {ButtonType} from 'antd/es/button';
import {ButtonHTMLType} from 'antd/es/button/button';
import cn from 'classnames';
import React, {CSSProperties, FC, MouseEvent} from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {TIconType} from 'components/dynamic-icon/dynamic-icon';

import './simple-action-button.less';

export interface ISimpleActionButtonProps {
    icon?: TIconType | '';
    type?: ButtonType;
    title?: string;
    style?: CSSProperties;
    disabled?: boolean;
    htmlType?: ButtonHTMLType;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    className?: string;
}

export const SimpleActionButton: FC<ISimpleActionButtonProps> = ({
    title,
    icon,
    type,
    onClick,
    className,
    ...props
}: ISimpleActionButtonProps) => (
    <Button
        onClick={onClick}
        type={type}
        className={cn(className, 'simple-action-btn')}
        {...props}
    >
        {icon && <DynamicIcon type={icon} />}
        {!!title && title}
    </Button>
);
